import "./../styles/service.css";
import React from 'react';
// import React from 'react';
const SmartPakcing = () => {
  return (
    <div className="service">
      <img src="/assets/service.png" alt="服务能力" />
      <div className="title">
        <div className="titleBefore">智慧停车系列</div>
        <div className="titleEnd">SMART PARKING</div>
        <div className="temp"></div>
      </div>

      <div className="content">
        <div className="content-title">方案价值</div>
        <div className="content-content">
          通过整合现有停车资源和数据，快速构建智能停车管理平台，实现高效、便捷的停车服务，提升城市交通管理水平。
        </div>
        <div className="content-title">云网优势</div>
        <div className="content-content">
          围绕政府停车监管、企业停车运营、公众停车服务三方需求，运用大数据、云计算、人工智能、高精度定位等技术，打造城市级停车资源统一纳管、企业级停车业务可视化运营、公众出行一站式导航全场景服务的数字化平台。
        </div>
        <img src="/assets/smartparking.png"   alt="数字孪生" />
        <div className="content-end">
          加入云网合作伙伴，开创新业务，获取技术、资源
        </div>
      </div>
    </div>
  );
};
export default SmartPakcing;
